import React from 'react';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';
import { connect } from 'react-redux';
import { activateModal } from '../../store/actions';

import { list } from '../../featureConfig';

import svgInline from '../SvgInline/SvgInline';

import planeIcon from './icon-plane.png';
import highwayIcon from './icon-highway.png';
import demographicsIcon from './icon-report-gray.png';
import printerIcon from './icon-printer-gray.png';
import folderIcon from './icon-folder.svg';
import folderIconActive from './icon-folder-active.svg';
import workforceIcon from '../../shared/assets/icon-workforce.svg';
import streetView from './icon-street-view.png';
import { getPropertyPdfLink } from '../../ajax/endpoints';

export function ListItemLinksComponent({
  property,
  type,
  saved,
  organizationId,
  onDemographicsClick,
  onAddToFavoritesClick,
  handleModalOpen,
  showESRIReports,
  showWorkforceReports,
  onModalClick,
  // dontShowAgain,
  // authenticated,
}) {
  // Team LOIS has requested the functionality for notifying a user they are not logged
  // into favorites be removed for now. The functionality will be commented out for when
  // they as to have it re-implemented.

  // const modalType = (dontShowAgain || authenticated || saved) ? 'folders' : 'first-time';
  const modalType = 'folders';
  const pdfLink = getPropertyPdfLink(type === 'buildings' ? 'building' : 'site', organizationId, property._id, property.appendAttachments);
  const nearestAirport = parseFloat(property.nearestAirport, 10).toFixed(1);
  const nearestInterstate = parseFloat(property.nearestInterstate, 10).toFixed(1);
  return (
    <ul className="list-links">
      {list.save &&
        <li
          data-tip={'Add/Remove From Folders'}
        >
          <a
            tabIndex="0"
            onClick={() => {
              handleModalOpen({
                properties: [property],
                propertyType: type,
                type: modalType,
                action: saved ? 'remove' : 'save',
              });
              onAddToFavoritesClick();
            }}
            className="list-links__save"
          >
            {saved ? svgInline(folderIconActive) : svgInline(folderIcon)}
          </a>
        </li>
      }
      {showESRIReports &&
        <li
          data-tip="ESRI Reports"
        >
          <a
            tabIndex="0"
            onClick={() => {
              handleModalOpen({ properties: [property], type: 'report' });
              onDemographicsClick();
            }}
            className="list-links__demographics"
          >
            <img src={demographicsIcon} alt="" />
          </a>
        </li>
      }
      {showWorkforceReports && (
        <li data-tip="Workforce Reports">
          <a
            tabIndex="0"
            onClick={() => {
              onModalClick('workforce-report', [property]);
            }}
            className="list-links__workforce"
          >
            {svgInline(workforceIcon, {
              height: '16px',
              width: '16px',
              top: '3px',
              position: 'relative',
            })}
          </a>
        </li>
      )}
      {list.print &&
        <li
          data-tip="Print Brochure"
        >
          <a
            className="list-links__print"
            target="_blank"
            rel="noopener noreferrer"
            href={pdfLink}
          >
            <img src={printerIcon} alt="" />
          </a>
        </li>
      }
      {(property.nearestAirport > 0) &&
        <li
          data-tip="Nearest Commercial Airport"
        >
          <img src={planeIcon} alt="" />
          <span>{nearestAirport} mi. </span>
        </li>
      }
      {(property.nearestInterstate > 0) &&
        <li
          data-tip="Nearest Interstate"
        >
          <img src={highwayIcon} alt="" />
          <span>{nearestInterstate} mi. </span>
        </li>
      }
      {
        property.coordinates &&
        <li data-tip="View in Google Street View">
          <a href={`https://maps.google.com/maps?q=&layer=c&cbll=${property.coordinates[1]},${property.coordinates[0]}&cbp=11,0,0,0,0`} target="_blank" rel="noopener noreferrer" className="list-links__streetview">
            <img className="street-view-img" src={streetView} alt="Link to Google Street View" />
          </a>
        </li>
      }
      <ReactTooltip
        place={'bottom'}
      />
    </ul>
  );
}

ListItemLinksComponent.propTypes = {
  property: PropTypes.object.isRequired,
  type: PropTypes.string,
  handleModalOpen: PropTypes.func,
  onDemographicsClick: PropTypes.func,
  onAddToFavoritesClick: PropTypes.func,
  organizationId: PropTypes.string.isRequired,
  saved: PropTypes.bool,
  showESRIReports: PropTypes.bool,
  showWorkforceReports: PropTypes.bool,
  onModalClick: PropTypes.func,
  // dontShowAgain: PropTypes.bool,
  // authenticated: PropTypes.bool,
};

export function mapStateToProps({ favorites, profile, viewer }) {
  return {
    dontShowAgain: favorites.dontShow,
    authenticated: profile.authenticated,
    showESRIReports: !!viewer.adminSettings.showESRIReports,
    showWorkforceReports: !!viewer.adminSettings.lightcastWorkforceData,
  };
}

export function mapDispatchToProps(dispatch) {
  return {
    onModalClick: (modal, properties) => { dispatch(activateModal(modal, properties)); },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ListItemLinksComponent);



// WEBPACK FOOTER //
// ./src/components/List/ListItemLinks.js